import * as React from 'react'

import { Alert, Button, Form, Select, Space } from 'antd'

import { transactionRequestStatus } from '../../../const'
import {
  $gateways,
  setWithdrawal,
  submitEditWithdrawalProcessingMethod,
} from '../../edit/model'
import { WithdrawalEdit } from '../../edit'
import { useStore } from 'effector-react'

type MessageShape = {
  message: string
}

type WithdrawalEditFormProps = {
  loading: boolean
  withdrawal: WithdrawalEdit
  error: MessageShape
}

export const WithdrawalEditForm: React.FC<WithdrawalEditFormProps> = ({
  loading,
  withdrawal,
  error,
}) => {
  const isEditable =
    withdrawal.status === transactionRequestStatus.pendingManager() ||
    withdrawal.status === transactionRequestStatus.fundsReserved()

  const gateways = useStore($gateways)

  const gwOptions = gateways.map((item) => {
    return {
      text: item.gatewayId + ' ' + item.internalName,
      value: item.gatewayId,
    }
  })

  const handleChange = (event: {
    currentTarget: { name: any; value: any }
  }) => {
    setWithdrawal({
      ...withdrawal,
      [event.currentTarget.name]: event.currentTarget.value,
    })
  }

  return (
    <Space>
      <Space>
        <Select
          value={withdrawal.gatewayId}
          placeholder="Choose new processing method"
          disabled={!isEditable}
          onChange={(value) =>
            handleChange({ currentTarget: { name: 'gatewayId', value } })
          }
          options={gwOptions.map((item) => ({
            label: item.text,
            value: item.value,
          }))}
          style={{ minWidth: 240 }}
        />

        <Button
          type="primary"
          onClick={() =>
            //@ts-ignore
            submitEditWithdrawalProcessingMethod({
              id: withdrawal.transactionId,
              gatewayId: withdrawal.gatewayId,
            })
          }
          disabled={!isEditable}
          loading={loading}
        >
          Update PS
        </Button>
      </Space>

      {error.message.length > 0 && (
        <Alert message={`Error code: ${error.message}`} type="error" />
      )}
    </Space>
  )
}
